
import {mapActions, mapGetters, mapMutations} from 'vuex'

export default {
	props: {
		pageTitle: String
	},
	data() {
		return {
			modalChooseCar: {
				component: 'modal-choose',
				visibility: true
			},
		}
	},
	computed: {
		...mapGetters({
			currentCar: 'modal/modal-choose/currentCar',
			totalSum: 'form/form-credit/totalSum',
			bank: 'banks/bank',
			benefitsTradeIn: 'benefits/benefitsTradeIn',
			benefitsSlider_traidin: 'benefits/benefitsSlider_traidin',
			settings: 'settings/settings/settings'

		})
	},
	methods: {
		...mapActions({
			openModal: 'modal/modal-main/openModal'
		}),
		chooseCar() {
			let payload = {
				modal_component: 'modal-choose',
				modal_title: 'Выберите автомобиль',
				modal_sub_title: '10 560 автомобилей в наличии'
			}
			this.openModal(payload)
		}
	}
}
